// {{url}}/v1/admin/setting/1

import apiManager from '@/services/API/apiManager'

const updatePageSettings = async (userId, queryObj) => {
    // {{url}}/v1/agent/application/5
    const updateSettings = apiManager.axios
      .patch(`/v1/admin/setting/${userId}`, queryObj)
      .then((response) => {
        return { status: 200, data: response.data.data };
      })
      .catch((err) => {
        return {
          status: err.response.status,
        };
      });
  
    return updateSettings;
  };

const getDefaultPageValue = async () => {
  const getSettings = apiManager.axios
    .get(`/v1/admin/setting`)
    .then((response) => {
      return {status: 200, data: response.data.data}
    })
    .catch((err) => {
      return {
        status: err.response.status,
      };
    });
    return getSettings
}

  export default {
    updatePageSettings,
    getDefaultPageValue
  }

